import { render, staticRenderFns } from "./EmployeeSummaryTasksTable.vue?vue&type=template&id=86f5aa7c&lang=pug"
import script from "./EmployeeSummaryTasksTable.vue?vue&type=script&lang=ts"
export * from "./EmployeeSummaryTasksTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmployeeSummaryTasksTable.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FEmployees%2FTemplate%2Fviews%2FSummary%2Fcomponents%2FEmployeeSummaryTasksTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports